import {
  AfterViewInit,
  ChangeDetectionStrategy, 
  Component, 
  Input,
  Output,
  OnChanges, 
  ViewEncapsulation,
  EventEmitter
} from '@angular/core';
import { ICardLimit } from '@knz/util';
 

@Component({
  selector: 'card-limit',
  exportAs: 'cardLimit',
  templateUrl: './card-limit.component.html',
  host: { '[class.card-limit]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardLimitComponent implements AfterViewInit, OnChanges {
  @Input() data: ICardLimit = {
    residue:0,
    limit: 0,
    limitUse: 0,
    lastLimit: 0,
    lastLimitUse: 0
  };
  @Output() itemClickEvent = new EventEmitter<any>();
  
 
  get photo(){
    let result="";
    if(this.data!=undefined && this.data.photo!=undefined && this.data.photo!=null && this.data.photo!=""){
      result= this.data.photo;
    }
    return result;
  }
  
  constructor() {}

  ngAfterViewInit() { 
  }

  ngOnChanges() { 
  }

  
  cardClick() { 
    this.itemClickEvent.emit(this.data);
  }
}
